import { ThemeEvents } from '@theme/events';

class CartAddConfirmation extends HTMLElement {
  #hideTimer;
  #showTimer;
  #returnFocus;

  connectedCallback() {
    document.addEventListener(ThemeEvents.cartUpdate, this.#handleCartUpdate);
    this.querySelector('[data-cart-confirmation-close]')?.addEventListener('click', this.#handleClose);
  }

  disconnectedCallback() {
    document.removeEventListener(ThemeEvents.cartUpdate, this.#handleCartUpdate);
    this.querySelector('[data-cart-confirmation-close]')?.removeEventListener('click', this.#handleClose);
    clearTimeout(this.#hideTimer);
    clearTimeout(this.#showTimer);
  }

  #handleCartUpdate = (event) => {
    const data = event.detail?.data;
    if (!data || data.didError || data.source !== 'product-form-component') return;

    this.#returnFocus = document.activeElement;
    clearTimeout(this.#showTimer);
    this.#showTimer = setTimeout(() => {
      const drawerIsOpen = document.querySelector('cart-drawer-component dialog[open]');
      if (drawerIsOpen) return;
      this.show();
    }, 220);
  };

  #handleClose = () => {
    this.hide();
    if (this.#returnFocus instanceof HTMLElement) this.#returnFocus.focus({ preventScroll: true });
  };

  show() {
    clearTimeout(this.#hideTimer);
    this.hidden = false;
    requestAnimationFrame(() => this.setAttribute('data-show', ''));
    this.#hideTimer = setTimeout(() => this.hide(), 7000);
  }

  hide() {
    clearTimeout(this.#hideTimer);
    this.removeAttribute('data-show');
    setTimeout(() => {
      if (!this.hasAttribute('data-show')) this.hidden = true;
    }, 180);
  }
}

if (!customElements.get('cart-add-confirmation')) {
  customElements.define('cart-add-confirmation', CartAddConfirmation);
}
